module.exports = __webpack_public_path__ + "static/media/ic_isologobranco.870c5c42.svg";